/* istanbul ignore file */

export enum TriggerRelationshipText {
    And = "and",
    Or = "or",
}
